import {
  ExcessiveStockPotentialInfo,
  LockedByKeys,
  sumLockedByOptions,
} from '../../categoryInsightsLib';

import { BarLinePartitionProps } from '@ydistri/ds';
import ExcessiveStockBarTooltipContent from './ExcessiveStockBarTooltipContent';
import { computePercentage } from '@ydistri/generic-utils';
import { CSSProperties } from 'react';

export interface ExcessiveStockBarSection {
  title: string;
  fields: LockedByKeys[];
  highlighted?: boolean;
}

export const getBarDataFromSection = (
  section: ExcessiveStockBarSection,
  data: ExcessiveStockPotentialInfo,
  highlightedColor: CSSProperties['backgroundColor'],
): BarLinePartitionProps => {
  const sum = section.fields.reduce((p, c) => p + data[c], 0);
  const totalSum = sumLockedByOptions(data);

  return {
    percentage: computePercentage(sum, totalSum, 2),
    tooltip: <ExcessiveStockBarTooltipContent data={data} section={section} />,
    minSizeToDisplayContent: 16,
    highlightedPercentage: section.highlighted && highlightedColor ? 100 : undefined,
    color: section.highlighted ? highlightedColor : undefined,
  };
};
